import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { RegistrationService } from 'src/app/core/services/registration.service';


@Component({
  selector: 'app-test-registration-receipt',
  templateUrl: './test-registration-receipt.component.html',
  styleUrls: ['./test-registration-receipt.component.scss']
})
export class TestRegistrationReceiptComponent implements OnInit, OnDestroy {

  testConfirmationEmail: string;
  registrationReceiptSubscription: Subscription;
  queryParamsSubscription: Subscription;
  token: string;
  userOrderId: number;
  loadingCompleted: boolean;
  isWebDelivery: boolean;

  constructor(
    private toastService: HotToastService,
    private registrationService: RegistrationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams
      .subscribe(params => {
        this.token = encodeURIComponent(params.token);
        this.userOrderId = params.userOrderId;
        this.isWebDelivery = params.isWebDelivery;
        if (this.token && this.userOrderId) {
          this.getTestRegistrationReceipt();
        }
        else {
          this.toastService.warning("Unable to load the page. Please contact Paragon.");
        }
      });
  }

  getTestRegistrationReceipt() {
    this.registrationReceiptSubscription = this.registrationService.getTestRegistrationReceipt(this.userOrderId, this.token, this.isWebDelivery)
      .subscribe(
        result => {
          this.testConfirmationEmail = result;
          this.loadingCompleted = true;
        },
        () => {
          this.toastService.warning("Unable to load the page. Please contact Paragon.");
        }
      );
  }

  print() {
    window.print();
  }

  ngOnDestroy(): void {
    this.registrationReceiptSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
  }

}
